// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"d1edd6b4","149":"94046118","207":"5b24f216","248":"77f0354c","483":"2c5f427a","501":"2499ea3a","599":"fb7085f9","748":"bb604bd3","829":"0056a88a"}[chunkId] + ".chunk.js";
};